import { render, staticRenderFns } from "./shequgonggao.vue?vue&type=template&id=73078ae6&scoped=true&"
import script from "./shequgonggao.vue?vue&type=script&lang=js&"
export * from "./shequgonggao.vue?vue&type=script&lang=js&"
import style0 from "./shequgonggao.vue?vue&type=style&index=0&id=73078ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73078ae6",
  null
  
)

export default component.exports